import * as $ from 'jquery';
import {Menu} from './Menu';

export class StickyHeader {

  protected headerSelector = '.js-header';
  protected headerStickyClass = 'header--small';
  protected header = document.querySelector(this.headerSelector);
  protected scrollOffset = 40;
  protected stickyHeaderBreakpoint = 1200;
  protected menu: Menu;

  constructor(menu: Menu) {
    this.menu = menu;
    if (!(this.header instanceof HTMLElement)) {
      return;
    }
    this.checkScrolled();
    window.onscroll = () => {
      this.checkScrolled();
    };
  }

  protected checkScrolled() {
    if (this.header) {
      if (window.pageYOffset > this.scrollOffset) {
        this.header.classList.add(this.headerStickyClass);
      } else {
        this.header.classList.remove(this.headerStickyClass);
        let outerWidth = $(window).outerWidth();
        if (outerWidth && outerWidth > this.stickyHeaderBreakpoint) {
          this.menu.closeBurgerMenu();
        }
      }
    }
  }
}
